import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Occasion } from 'src/app/data/models/interfaces/occasion.abstract';
import moment from 'moment';

@Component({
  selector: 'app-bottom-sheet-occasion',
  templateUrl: 'bottom-sheet-occasion.component.html',
  styleUrls: ['./bottom-sheet-occasion.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BottomSheetOccasionComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: Occasion
  ) {}

  get createdAtDay(): string {
    return moment(this.data.createdAt).locale('pt-br').format('L');
  }

  get createdAtHour(): string {
    return moment(this.data.createdAt).locale('pt-br').format('LT');
  }

  get updatedAtDay(): string {
    return moment(this.data.updatedAt).locale('pt-br').format('L');
  }

  get updatedAtHour(): string {
    return moment(this.data.updatedAt).locale('pt-br').format('LT');
  }

  get scheduledDate(): string {
    return moment(this.data.releaseDate).locale('pt-br').format('L');
  }

  get scheduledHour(): string {
    return moment(this.data.releaseDate).locale('pt-br').format('LT');
  }

  ngOnInit(): void {}
}
